import { createAsyncThunk } from '@reduxjs/toolkit';
import institutionService from 'api/institutionService';
import { notifyApiError } from 'api/apiUtils';

export const saveReporter = createAsyncThunk(
  'users/saveReporter',
  async ({ institutionId, data }, { rejectWithValue, extra: { i18n } }) => {
    try {
      const response = await institutionService.saveReporter(
          institutionId, data
      );
      return response;
    } catch (err) {
      notifyApiError(i18n, err);
      return rejectWithValue(err);
    }
  }
);

export const updateReporter = createAsyncThunk(
  'users/updateReporter',
  async ({ institutionId, data }, { rejectWithValue, extra: { i18n } }) => {
    try {
      const response = await institutionService.updateReporter(
          institutionId, data
      );
      return response;
    } catch (err) {
      notifyApiError(i18n, err);
      return rejectWithValue(err);
    }
  }
);

export const deleteReporter = createAsyncThunk(
  'users/deleteReporter',
  async ({ institutionId, userId }, { rejectWithValue, extra: { i18n } }) => {
    try {
      const response = await institutionService.deleteReporter(
        institutionId,
        userId
      );
      return response;
    } catch (err) {
      notifyApiError(i18n, err);
      return rejectWithValue(err);
    }
  }
);

export const updateMainUser = createAsyncThunk(
  'users/updateMainUser',
  async ({ institutionId, userId }, { rejectWithValue, extra: { i18n } }) => {
    try {
      const response = await institutionService.updateMainUser(
        institutionId,
        userId
      );
      return response;
    } catch (err) {
      notifyApiError(i18n, err);
      return rejectWithValue(err);
    }
  }
);

export const getInstitutionUsersList = createAsyncThunk(
  'users/getInstitutionUsersList',
  async (institutionId, { rejectWithValue, extra: { i18n } }) => {
    try {
      const response = await institutionService.getInstitutionUsers(
        institutionId,
        true
      );
      return response;
    } catch (err) {
      notifyApiError(i18n, err);
      return rejectWithValue(err);
    }
  }
);


export const getInstitutionObligations = createAsyncThunk(
    'users/getInstitutionObligations',
    async (institutionId, { rejectWithValue, extra: { i18n } }) => {
        try {
            const response = await institutionService.getInstitutionObligations(
                institutionId
            );
            return response;
        } catch (err) {
            notifyApiError(i18n, err);
            return rejectWithValue(err);
        }
    }
);

export const setReporterToObligations = createAsyncThunk(
    'users/setReporterToObligations',
    async ({ institutionId, reporterId, obligations }, { rejectWithValue, extra: { i18n } }) => {
        try {
            const response = await institutionService.setReporterToObligations(
                institutionId, reporterId, obligations
            );
            return response;
        } catch (err) {
            notifyApiError(i18n, err);
            return rejectWithValue(err);
        }
    }
);
